import { Injectable } from "@angular/core";
import { Subject } from "rxjs/Subject";

import { BtLocalService } from './local-data-services/bt-local.service';
import { MeasureContextLocalService } from './local-data-services/measure-context-local.service';
import { PKLocalService } from './local-data-services/pk-local.service';
import {Line, Measure, MeasureContext, PK} from '../models/models';
import { MeasureLocalService } from './local-data-services/measure-local.service';

@Injectable()
export class MeasureInputService {

  private currentMeasureUpdatedSource = new Subject<Measure>();
  private currentPkUpdatedSource = new Subject<PK>();
  private measureContextUpdatedSource = new Subject<MeasureContext>();
  private previousPkUpdatedSource = new Subject<PK>();

  currentMeasureUpdated$ = this.currentMeasureUpdatedSource.asObservable();
  currentPkUpdated$ = this.currentPkUpdatedSource.asObservable();
  measureContextUpdated$ = this.measureContextUpdatedSource.asObservable();
  previousPkUpdated$ = this.previousPkUpdatedSource.asObservable();

  constructor() {
  }

  public static getCurrentMeasure(): Measure {
    let measure = Object.assign(new Measure(BtLocalService.getBT()), MeasureLocalService.getCurrentMeasure());
    measure.pk = Object.assign(new PK(), measure.pk);
    return measure;
  }

  public static getMeasureContext(): MeasureContext {
    return Object.assign(new MeasureContext(), MeasureContextLocalService.getCurrentMeasureContext());
  }

  public static getCurrentPk(): PK {
    return Object.assign(new PK(), PKLocalService.getCurrentPk());
  }

  public static getPreviousPk(): PK {
    return Object.assign(new PK(), PKLocalService.getPreviousPk());
  }

  public updateCurrentMeasure(measure?: Measure) {
    measure.pk = Object.assign(new PK(), measure.pk);
    MeasureLocalService.setCurrentMeasure(measure ? measure : new Measure(BtLocalService.getBT()));
    this.currentMeasureUpdatedSource.next(measure);
  }

  public updateMeasureContext(measureContext: MeasureContext) {
    MeasureContextLocalService.setCurrentMeasureContext(measureContext);
    this.measureContextUpdatedSource.next(measureContext);
  }

  public updateCurrentPk(pk?: PK, line?: Line) {
    if(line) pk.setLine(line);
    PKLocalService.setCurrentPk(pk);
    this.currentPkUpdatedSource.next(pk);
  }

  public updatePreviousPk(pk?: PK) {
    if(pk !== null) {
      PKLocalService.setPreviousPk(pk);
    } else {
      PKLocalService.deletePreviousPk();
    }
    this.previousPkUpdatedSource.next(pk);
  }
}



// WEBPACK FOOTER //
// ./src/app/core/measure-input.service.ts